import * as React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { ILoginForm } from './types';
import { validateEmail } from 'src/Utilities/Validations';
import whiteLineBg from '../../../Assets/whiteLineBg.png';
const styles = (theme: any) => ({
    loginRoot: {
        minHeight: '100vh',
        width: '100vw',
        position: 'fixed' as 'fixed',
        top: '0px',
        background: `url(${whiteLineBg}) center no-repeat fixed`,
        backgroundSize: 'cover',
    },
    overlay: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        overflow: 'auto',
        position: 'fixed' as 'fixed',
        top: '0px',
        width: '100%',
        height: '100%',
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative' as 'relative',
    },
    card: {
        top: '10vh',
        position: 'relative' as 'relative',
        background: '#FFFFFF',
        boxShadow: '0px 3px 12px #00000012',
        borderRadius: '20px',
        padding: '80px',
        [theme.breakpoints.down('lg')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '47px 32px',
        },
        textAlign: 'center' as 'center',
    },
    heading: {
        fonFamily: 'League Spartan',
        fontWeight: 500,
        fontSize: '32px',
        lineHeight: '38px',
        textTransform: 'uppercase' as 'uppercase',
        marginBotom: '56px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
        },
    },
    field: {
        width: '100%',
        marginTop: '20px',
        borderRadius: '0px',
        '& div': {
            borderRadius: '0px',
        },
        '& input': {
            background: '#fff',
            color: '#000',
            borderRadius: '0px',
        },
    },
    submitBtnWrapper: {
        textAlign: 'center' as 'center',
    },
    submitBtn: {
        fontWeight: 500,
        background: '#EF0017',
        textTransform: 'none' as 'none',
        borderRadius: '24px',
        fontFamily: 'Poppins',
        color: 'white',
        fontSize: '14px',
        lineHeight: '18px',
        padding: '12px 24px',
        width: '175px',
        boxSize: 'borderBox',
        height: '48px',
        [theme.breakpoints.down('xs')]: {
            height: '32px',
            padding: '8px 16px',
            width: '200px',
        },
        '&:disabled': {
            background: '#cccccc',
            color: '#666666',
        },
    },
    errors: {
        border: '3px solid red',
    },
    message: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontFamily: 'Poppins',
        fontSize: '14px',
        lineHeight: '18px',
        marginTop: '16px',
    },
    messageBox: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontFamily: 'Poppins',
        fontSize: '14px',
        lineHeight: '18px',
        marginTop: '24px',
        maxWidth: '380px',
    },
    resetPassword: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontFamily: 'Poppins',
        fontSize: '14px',
        lineHeight: '18px',
    },
    link: {
        color: '#EF0017',
        paddingLeft: '4px',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    textField: {
        width: '100%',
        display: 'flex',
        aligItems: 'flex-start',
        flexDirection: 'column' as 'column',
        marginBottom: '40px',
        '&:last-child': {
            marginBottom: '0px',
        },
    },

    labelField: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left' as 'left',
        fontWeight: 500,
    },
    inputField: {
        border: 'none',
        borderBottom: '1px solid black',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    inputFieldError: {
        border: 'none',
        borderBottom: '1px solid red',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    formWrapper: {
        marginTop: '24px',
        padding: '0px 25px',
    },
    erroSpan: {
        textAlign: 'left' as 'left',
        color: 'red',
        fontFamily: 'Poppins',
        fontSize: '12px',
        margin: '8px',
    },
    successSpan: {
        textAlign: 'left' as 'left',
        color: 'green',
        fontFamily: 'Poppins',
        fontSize: '12px',
        margin: '8px',
    },
    footer: {
        marginTop: '50px',
        marginBottom: '15px',
        position: 'absolute' as 'absolute',
        bottom: '0px',
        left: '40%',
        right: '40%',
        [theme.breakpoints.down('md')]: {
            left: '40%',
            right: '40%',
        },
        [theme.breakpoints.down('sm')]: {
            left: '30%',
            right: '30%',
        },
        [theme.breakpoints.down('xs')]: {
            left: '20%',
            right: '20%',
        },
        fontSize: '12px',
        fontStyle: 'Poppins',
        textAlign: 'center' as 'center',
    },
});

interface IProps {
    classes: any;
    onSubmit: (method: string) => void;
    form: ILoginForm;
    onChange: (
        form: 'login' | 'register',
        field: string
    ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    emailIsInvalid: (form: 'login' | 'register') => boolean;
    formIsDisabled: (form: 'login' | 'register') => boolean;
}

const statusList = [422, 409, 200, 404, 401]

export const resetPassword = (props: IProps) => {
    const { classes } = props;

    const errorSendingEmail = `There was an error sending your password reset email. Email info@keyframesports.com for help.`
    const [emailSent, setEmailSent]: any = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [error, setError]: any = React.useState();
    const [success, setSuccess]: any = React.useState();
    const [submitting, setSubmitting]: any = React.useState(false);

    React.useEffect(() => {
        const isInvalid = email.length > 0 && !validateEmail(email);
        setError(isInvalid);
    }, [email]);

    const sendEmail = async () => {
        const body = {
            email
        };
        const url = process.env.REACT_APP_ALEPH_URI +
            '/api-v1/authentication/password-reset/request';
        setSubmitting(true);
        const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        const status = await res.status;
        if (status === statusList[2]) {
            setSubmitting(false);
            setEmailSent(true);
            setSuccess('Reset link has been sent, please check your email.');
        } else {
            setSubmitting(false);
            setError(errorSendingEmail);
        }
    };

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };
    return (
        <div className={classes.loginRoot}>
            <div className={classes.overlay}>
                <div className={classes.content}>
                    <div className={classes.card}>
                        <div className={classes.heading}>RESET PASSWORD</div>
                        <div className={classes.messageBox}>
                            Enter your email address below and we'll email you a
                            link to reset your password
                        </div>
                        <form className={classes.formWrapper}>
                            <div className={classes.textField}>
                                <div className={classes.labelField}>Email</div>
                                <input
                                    type='email'
                                    id='username'
                                    onChange={changeHandler}
                                    value={email}
                                    className={
                                        error
                                            ? classes.inputFieldError
                                            : classes.inputField
                                    }
                                    autoComplete='off'
                                    placeholder='Email *'
                                    required={true}
                                ></input>
                                <span className={classes.erroSpan}>
                                    {error ? 'Invalid email' : null}
                                </span>

                                <span className={classes.successSpan}>
                                    {success ? success : null}
                                </span>
                            </div>

                            <div className={classes.submitBtnWrapper}>
                                <Button
                                    disabled={error}
                                    variant='contained'
                                    color='primary'
                                    onClick={sendEmail}
                                    className={classes.submitBtn}
                                >
                                    Send link to email
                                </Button>
                            </div>

                            <div className={classes.message}>
                                <Link to='/login' className={classes.link}>
                                    Cancel
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={classes.footer}>© Keyframe Sports 2024</div>
        </div>
    );
};

export const ResetPassword = withStyles(styles)(resetPassword);



// WEBPACK FOOTER //
// ./src/Features/UserManagement/components/ResetPassword.tsx